var mixin = {
  methods: {
    getFileType: function (fileName) {
      if (!fileName) {
        return ''
      }
      var extension = fileName.split('.').pop()
      extension = extension.toLowerCase()
      if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'gif') {
        return 'image/' + extension
      }
      if (extension === 'pdf' || extension === 'doc' || extension === 'txt') {
        return 'application/' + extension
      }
      return 'unknown'
    }
  }
}

export default mixin
